module.exports = __webpack_public_path__ + "static/zh-logo100-web-398db41525395fbc48d350e3c91f7623.svg";